export default (player) => {
  player.on("ready", () => {
    if (!player?.config?.logo || player?.config?.logo_added) {
      return;
    }

    jQuery(
      `<img src="${
        player?.config?.logo
      }" class="presto-player__logo is-bottom-right" style="max-width: ${
        player?.config?.logo_width || 150
      }px">`
    ).insertBefore(player?.elements?.controls);

    player.config.logo_added = true;
  });
};
